import { render } from "./FilesShow.vue?vue&type=template&id=4cff101c&scoped=true"
import script from "./FilesShow.vue?vue&type=script&lang=js"
export * from "./FilesShow.vue?vue&type=script&lang=js"

import "./FilesShow.vue?vue&type=style&index=0&id=4cff101c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cff101c"]])

export default __exports__